import React, { useEffect, useState } from "react";
import style from "styled-components";
import {
  Form,
  InputContainer,
  ButtonsContainer,
  Button,
  ErrorSpan,
  AmountButton,
} from "./DepositElements";
import { useTranslation } from "react-i18next";
import { formatNumber, toLocaleString } from "../../utils/tools";
import { useSelector } from "react-redux";
import { selectCurrency } from "../../features/user/userSlice";
import astropasarela from '../../assets/images/astropasarela.png';
import Rastro from '../../assets/images/RECARGACONASTROPAY.svg';
import astropayLogo from '../../assets/images/astropay002.png';
import { selectLimites } from "../../features/limitaciones/limitacionesSlice";
import astrochile from '../../assets/images/ASTROCHILE1.png';
import astrocop from '../../assets/images/ASTROCOP1.png';
import astroars from '../../assets/images/ASTROARS.png';

const FormAstroPay = ({
  form,
  handleChange,
  handleClose,
  handleSubmit,
  loading,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);
  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);
  const limitaciones = useSelector(selectLimites);

  const monedasLimites = {
    ARS: {minimo: 1000, maximo: 0},
    CLP: {minimo:5000, maximo: 10000000},
    COP: {minimo:5000, maximo: 5000000},
    $: {minimo: 1, maximo: 20000},
  }

  const [minimo, setMinimo] = useState(monedasLimites[moneda].minimo)
  const [maximo, setMaximo] = useState(monedasLimites[moneda].maximo)

  useEffect(()=>{
    if(limitaciones.minimo_deposito>0 && limitaciones.minimo_deposito > minimo) setMinimo(limitaciones.minimo_deposito) 
    if(limitaciones.maximo_deposito>0 && limitaciones.maximo_deposito < maximo) setMaximo(limitaciones.maximo_deposito) 
  },[limitaciones])


  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll('.', '').replace(',', '.')));
    if(e.target.value==='') setMonto(0);
  }
  const changeAmount = (valor) => {
      handleMonto({target: {value: valor, name: 'monto1'}});
    }

  return (
    <Form className={'astropay'}>
      <InputContainer>
        <label>{t('deposit.lbl-amount')}</label>
      </InputContainer>
      {
        moneda === '$' ? (
          <AmountButton>
            <Button onClick={()=>{changeAmount('10,00')}}>$10</Button>
            <Button onClick={()=>{changeAmount('50,00')}}>$50</Button>
            <Button onClick={()=>{changeAmount('100,00')}}>$100</Button>
            <Button onClick={()=>{changeAmount('200,00')}}>$200</Button>
          </AmountButton>
        ) : moneda === 'ARS' ? (
          <AmountButton>
            <Button onClick={() => {changeAmount('5.000,00')}}>5.000 ARS</Button>
            <Button onClick={() => {changeAmount('10.000,00')}}>10.000 ARS</Button>
            <Button onClick={() => {changeAmount('50.000,00')}}>50.000 ARS</Button>
            <Button onClick={() => {changeAmount('100.000,00')}}>100.000 ARS</Button>
          </AmountButton>
        ) : moneda === 'COP' ? (
           <AmountButton>
            <Button onClick={() => {changeAmount('10.000,00')}}>10.000 COP</Button>
            <Button onClick={() => {changeAmount('20.000,00')}}>20.000 COP</Button>
            <Button onClick={() => {changeAmount('50.000,00')}}>50.000 COP</Button>
            <Button onClick={() => {changeAmount('100.000,00')}}>100.000 COP</Button>
          </AmountButton>
        ) : moneda === 'CLP' ? (
           <AmountButton>
            <Button onClick={() => {changeAmount('10.000,00')}}>10.000 CLP</Button>
            <Button onClick={() => {changeAmount('20.000,00')}}>20.000 CLP</Button>
            <Button onClick={() => {changeAmount('50.000,00')}}>50.000 CLP</Button>
            <Button onClick={() => {changeAmount('100.000,00')}}>100.000 CLP</Button>
          </AmountButton>
        ):null
      }
      <InputContainer>
          <input type='text' placeholder='0,00' name='monto1' value={form.monto1} onChange={(e)=>handleMonto(e)}/>
          {(monto<minimo&&blur)&&<ErrorSpan>{t("deposit.amount-greater-than")} {toLocaleString(minimo)}  {moneda}</ErrorSpan>}

          {monto > maximo && moneda !== 'ARS' && 
            <ErrorSpan>{t("deposit.amount-less-than")} {toLocaleString(maximo)} {moneda}</ErrorSpan>
          }
  
      </InputContainer>
      <img src={Rastro} alt='astropay' className={'astro1'} style={{width:'43%', marginLeft: '28%', marginTop: '5%', marginBottom:'2%'}}/>
      
      {moneda === 'CLP' && (
        <img src={astrochile} alt='Pasarelas astropay' className={'astro3'} style={{width:'100%', marginTop: '0%', marginLeft: '-0.5%'}}/>
      )}

      {moneda === 'COP' && (
        <img src={astrocop} alt='Pasarelas astropay' className={'astro4'} style={{width:'100%', marginTop: '0%', marginLeft: '-0.5%'}}/>
      )}

      {moneda === 'ARS' && (
        <img src={astroars} alt='Pasarelas astropay' className={'astro5'} style={{width:'100%', marginTop: '0%', marginLeft: '1%'}}/>
      )}

      {moneda === '$'  && (
        <img src={astropasarela} alt='Pasarelas astropay' className={'astro2'} style={{width:'120%', marginTop: '-7%', marginLeft: '-10%'}}/>
      )}
      <ButtonsContainer style={{marginTop:'-90px'}}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-back")}
        </Button>
        <Button primary={true} disabled={loading || monto < minimo || (monto > maximo && moneda !== "ARS")} onClick={handleSubmit}>
          {loading ?  t("deposit.loading") : t("deposit.btn-next")}
        </Button>
      </ButtonsContainer>
    </Form>
  );
};

export default FormAstroPay;
